<div class="user-guide-text">
  New to Sympheny? We'll help you get started. See our user guide
  <a
    class="user-guide-link"
    target="_blank"
    href="https://docs.sympheny.com/web-app/"
    >here</a
  >.
</div>
